/**
 * EnvyCentral Messaging Widget
 *
 * Embeddable chat widget using Web Components + Shadow DOM.
 *
 * Usage:
 *   <script src="https://cdn.envycentral.com/widget/envy-chat-widget.js"></script>
 *   <envy-chat-widget
 *     data-api-key="pk_live_abc123..."
 *     data-api-url="https://messaging.envycentral.com"
 *     data-brand-name="Acme Window Washing"
 *     data-primary-color="#4f46e5"
 *   ></envy-chat-widget>
 */

import { EnvyChatWidget } from './components/EnvyChatWidget';

// Register the custom element (idempotent)
if (!customElements.get('envy-chat-widget')) {
  customElements.define('envy-chat-widget', EnvyChatWidget);
}

// Export for programmatic use
export { EnvyChatWidget };
export type {
  WidgetConfig,
  WidgetTheme,
  WidgetPosition,
  MessageResponse,
  ConversationResponse,
} from './types';
